import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SearchBar() {
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    const term = q.trim();
    if (term) navigate(`/search?q=${encodeURIComponent(term)}`);
  };

  return (
    <form onSubmit={onSubmit} className="flex w-full">
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search mobiles, laptops, CCTV…"
        className="min-w-0 flex-1 rounded-l-md border border-slate-300 px-3 py-2 text-base focus:outline-none sm:text-sm"
      />
      <button
        type="submit"
        className="shrink-0 rounded-r-md bg-brand-500 px-3 text-sm text-white sm:px-4"
      >
        Search
      </button>
    </form>
  );
}
